import * as moment from "moment/moment";

// Interfaz para el resultado general del schedule
export interface IResultReportm {
  count: number;
  next: string | null;
  previous: string | null;
  results: IReportm[];
}

export class User {
  email: string;
  last_login: moment.Moment;

  constructor(data: { email: string; last_login: string }) {
    this.email = data.email;
    this.last_login = moment(data.last_login); // Convert last_login to Moment
  }
}
export type ExportableFieldType = 'date' | 'datetime' | 'currency' | 'number' | 'string';

export interface ExportableField {
  key: string;
  label: string;
  /**
   * Semantic type for the field. Drives Excel export formatting:
   *  - 'date'     → Excel date cell with `m/d/yyyy` number format
   *  - 'datetime' → Excel date cell with `m/d/yyyy h:mm` number format
   *  - 'currency' → numeric cell with currency format
   *  - 'number'   → numeric cell
   *  - 'string'   → plain text (default when omitted)
   */
  type?: ExportableFieldType;
  selected: boolean;
}
// Clase para el resultado general del Reportm
export class ResultReportm {
  count: number;
  next: string | null;
  previous: string | null;
  results: Reportm[];

  constructor(result?: IResultReportm) {
    if (result) {
      this.count = result.count;
      this.next = result.next;
      this.previous = result.previous;
      this.results = result.results ? Reportm.fromObjectArray(result.results) : [];
    } else {
      this.count = 0;
      this.next = null;
      this.previous = null;
      this.results = [];
    }
  }

  static fromObject(result: IResultReportm): ResultReportm {
    return new ResultReportm(result);
  }
}

// Interfaz para cada Reportm
/**
 * {
            "billing_tin": "522248589",
            "owner_id": 1792,
            "member_name": "Minerva Valdez",
            "dob": "1979-05-14",
            "date_time": null,
            "icd10_code": "I82412, I82432, I82462, I82499, I824Y9, I82502",
            "icd10_code_description": null,
            "hcc_status": "Completed",
            "email": null,
            "phone_number": "5169026413",
            "mco_name": "Healthfirst",
            "hcc_category": "267",
            "hcc_description": "Deep Vein Thrombosis And Pulmonary Embolism"
        },
 */
export interface IReportm {
  id?: number;
  full_name: string;
  last_login: moment.Moment;
  member_name: string;
  mco_name: string;
  dob: moment.Moment;
  date_time: string;
  measure_code: string;
  hcc_status: string;
  icd10_code: string;
  status: string;
  phone_number: string;
  last_visit_date: moment.Moment | null;
  due_date: string;
  messed_date: moment.Moment | null;
  address: string;
  user: { email: string; last_login: string };
  full_name_display:string;
  line_of_business:string;
  reporting_period:string;
  pcp_name:string;
  measure_description:string;
  gender:string;
  member_id:string;
  non_user_flag:string;
  app_checked: string | null;
  claim_thru_date: string | null;
  billing_tin: string;
  owner_id: number;
  email: string | null;
  icd10_code_description: string | null;
  hcc_category: string;
  hcc_description: string;
  hcc_model: string | null;
  last_date_of_service: any | null;
  effective_period: string | null;
  role: string | null;
}

// Clase para cada Reportm
export class Reportm {
  full_name: string;


  id?: number;
  member_name: string;
  mco_name: string;
  dob: moment.Moment;
  hcc_status: string;
  icd10_code: string;
  date_time: string;
  measure_code: string;
  status: string;
  phone_number: string;
  last_visit_date: moment.Moment | null;
  messed_date: moment.Moment | null;
  address: string;
  user: User | null;
  full_name_display:string;
  line_of_business:string;
  reporting_period:string;
  pcp_name:string;
  measure_description:string;
  gender:string;
  member_id:string;
  non_user_flag:string;
  app_checked: string | null;
  claim_thru_date: string | null;
  billing_tin: string;
  owner_id: number;
  email: string | null;
  icd10_code_description: string | null;
  hcc_category: string;
  hcc_description: string;
  hcc_model: string | null;
  last_date_of_service: any | null;
  effective_period: string | null;
  role: string | null;
  due_date: string;
  constructor(ent?: IReportm) {
    if (ent) {
      this.full_name = ent.full_name;


      this.user = ent.user ? new User(ent.user) : null;
      this.id = ent.id;
      this.member_name = ent.member_name;
      this.mco_name=ent.mco_name;
      this.hcc_status = ent.hcc_status;
      this.icd10_code = ent.icd10_code;
      this.dob = moment(ent.dob);
      this.date_time = ent.date_time;
      this.measure_code = ent.measure_code;
      this.due_date = ent.due_date;

      this.phone_number = ent.phone_number;
      this.status = ent.status;
      this.last_visit_date = moment(ent.last_visit_date);
      this.messed_date = moment(ent.messed_date);
      this.address = ent.address;
      this.full_name_display = ent.full_name_display;
      this.line_of_business = ent.line_of_business;
      this.reporting_period = ent.reporting_period;
      this.pcp_name= ent.pcp_name;
      this.measure_description=ent.measure_description;
      this.gender= ent.gender;
      this.member_id=ent.member_id;
      this.non_user_flag=ent.non_user_flag;
      this.app_checked = ent.app_checked ?? null;
      this.claim_thru_date = ent.claim_thru_date;
      this.billing_tin = ent.billing_tin;
      this.owner_id = ent.owner_id;
      this.email = ent.email;
      this.icd10_code_description = ent.icd10_code_description;
      this.hcc_category = ent.hcc_category;
      this.hcc_description = ent.hcc_description;
      this.hcc_model = ent.hcc_model;
      this.last_date_of_service = ent.last_date_of_service;
      this.effective_period = ent.effective_period;
      this.role = ent.role;

    }
  }

  static fromObject(ent: IReportm): Reportm {
    return new Reportm(ent);
  }

  static fromObjectArray(ent: IReportm[]): Reportm[] {
    return ent.map(item => new Reportm(item));
  }
}
